<form>
  <div mat-dialog-content class="thermal-theme">

    @if (data.equipment.fromProtocol) {
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>
              {{ 'protocolEdit.dialog.equipment.type.label' | translate }} {{ 'common.inProtocol' | translate }}
            </mat-label>
            <mat-select required name="idTypeProtocol" [ngModel]="data.equipment.idTypeProtocol" disabled>
              @for (item of equipmentTypes; track item) {
                <mat-option [value]="item.id">
                  {{ 'equipmentType.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="equipmentProtocol" [(ngModel)]="data.equipment.equipmentProtocol" disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="makerProtocol" [(ngModel)]="data.equipment.makerProtocol" disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="modelProtocol" [(ngModel)]="data.equipment.modelProtocol" disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="serialNumProtocol" [(ngModel)]="data.equipment.serialNumProtocol" disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="internalIdProtocol" [(ngModel)]="data.equipment.internalIdProtocol" disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="locationProtocol" [(ngModel)]="data.equipment.locationProtocol" disabled>
          </mat-form-field>
        </div>
      </div>
    }

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select required name="idType" [(ngModel)]="data.equipment.idType">
            @for (item of equipmentTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'equipmentType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <!--<div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }}</mat-label>
        <input matInput
          name="equipment" [(ngModel)]="data.equipment.equipment" required>
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.equipment.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>-->

    @if (data.equipment.idType === 1 && data.isDisabled) {
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.name.label' | translate }}</mat-label>
          <input matInput name="name" [(ngModel)]="data.equipment.internalId" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
            placeholder="{{ 'protocolEdit.dialog.equipment.name.label' | translate }}"
            (keyup)="lookupEquipment($event)" required>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="onEquipmentChange($event, trigger)">
            @for (item of equipmentAutoComplete; track item; let index = $index) {
              <mat-option [value]="item">
                {{ item.name}} ({{item.serialNum}})
              </mat-option>
            }
          </mat-autocomplete>
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.equipment.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50">
        <a class="under-card-link" style="cursor: pointer;margin: inherit;" (click)="createEquipment()">
          {{ 'calibrateEquipmentEdit.general.equipment.notExists' | translate }}
        </a>
      </div>
    }

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ data.equipment.idType === 1 ? ('protocolEdit.dialog.equipment.equipment.label' | translate) : ( 'protocolEdit.dialog.equipment.item.label' | translate)}}</mat-label>
        <input matInput name="item" [disabled]="disabledLabel()"
          [(ngModel)]="data.equipment.equipment">
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
         <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }}</mat-label>
        <input matInput name="maker" [disabled]="disabledLabel()"
          [(ngModel)]="data.equipment.maker">
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.maker.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }}</mat-label>
        <input matInput placeholder="{{ 'protocolEdit.dialog.equipment.model.label' | translate }}" name="model" [disabled]="disabledLabel()"
          [(ngModel)]="data.equipment.model">
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.model.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
        <input matInput placeholder="{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}" [disabled]="disabledLabel()"
          name="serialNum" [(ngModel)]="data.equipment.serialNum">
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.serialNum.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }}</mat-label>
        <input matInput placeholder="{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }}" [disabled]="disabledLabel()"
          name="internalId" [(ngModel)]="data.equipment.internalId">
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.internalId.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }}</mat-label>
        <input matInput placeholder="{{ 'protocolEdit.dialog.equipment.location.label' | translate }}" name="location" [disabled]="disabledLabel()"
          [(ngModel)]="data.equipment.location" required>
        <mat-error>
          {{ 'protocolEdit.dialog.equipment.location.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

  </div>

  <div fxLayout="row" class="flexwrap">
    @if (requiredReason()) {
      <div fxFlex="100">
        <mat-label>{{ 'common.reasonChange' | translate }}</mat-label>
        <textarea rows="5" matAutosizeMinRows="5" matInput
        [(ngModel)]="data.equipment.reasonChange" name="reasonChange" required style="resize: none;"></textarea>
      </div>
    }
  </div>

  @if (data.equipment.fromProtocol) {
    <div fxLayout="column" class="flexwrap">
      <div fxFlex="100">
        <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.equipment.showDiffInDeviations">
          {{ 'protocolEdit.dialog.equipment.showDiffInDeviations.label' | translate }}
        </mat-checkbox>
      </div>
      <div fxFlex="100">
        <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.equipment.showDiffInObservations">
          {{ 'protocolEdit.dialog.equipment.showDiffInObservations.label' | translate }}
        </mat-checkbox>
      </div>
    </div>
  }

</div>
<div mat-dialog-actions class="thermal-theme">
  <div fxFlex></div>
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>

</form>